var render = function render(){var _vm=this,_c=_vm._self._c;return _c('e-dialog',{attrs:{"value":true,"persistent":"","description":"","width":"400","title":_vm.$t('failed_chunk_message'),"button-submit":{label: 'Refresh'}},on:{"click:submit":_vm.onSubmit}})
}
var staticRenderFns = []

export { render, staticRenderFns }